import { ContentfulConfigs } from '@vfmfe/foundations';

import { cf } from '../utils/contentful';
import { THeader } from '../types';

/**
 * Fetches the header data from Contentful using REST API
 */
export default async function getHeader({
    locale,
    preview = false,
    config,
    name
}: { locale?: string; preview?: boolean; config?: ContentfulConfigs; name?: string } = {}): Promise<THeader | null> {
    const baseParams = {
        content_type: 'navigationAssemblyModel',
        locale,
        include: 10,
        preview
    };

    // Try to fetch by specific analyticsId
    const headerById = await cf<THeader[]>(
        {
            ...baseParams,
            'fields.analyticsId': name
        },
        config
    );

    if (headerById && headerById.length > 0) return headerById[0];

    // Fallback to any header of this type
    const anyHeader = await cf<THeader[]>(baseParams, config);

    return anyHeader?.[0] ?? null;
}
